import script from "./ClaimsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ClaimsPage.vue?vue&type=script&setup=true&lang=js"

import "./ClaimsPage.vue?vue&type=style&index=0&id=a55d424c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a55d424c"]])

export default __exports__